import "./Home.scss";

const Home = () => {
  return (
    <section className="homepageSection">
      <h1 className="home-welcome">You lost it, we <em id="found">Foun'd</em> it! <br></br>
						{/* Press the <img style={{ height: "50px" }}
            src="https://static.thenounproject.com/png/1400400-200.png"
						/> icon <br></br> */}
						Look around for your lost items!</h1>

      {/* <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam vulputate
        magna ut urna lobortis suscipit. Vestibulum auctor enim ut nibh
        molestie, ut euismod justo finibus. Donec in lectus eget erat commodo
        euismod eget facilisis dui. Duis ullamcorper libero sem, non feugiat
        quam iaculis nec. Morbi nec lacus blandit elit hendrerit lacinia. Morbi
        id elit laoreet, vestibulum arcu ut, suscipit lectus. Aliquam volutpat
        tortor sed felis varius, eu blandit urna tristique. Donec luctus euismod
        nibh eget gravida. Pellentesque nec ligula tempus, aliquet ligula eu,
        accumsan neque. Proin dapibus ultrices urna, ut sagittis ligula
        tristique ut. Suspendisse mi eros, viverra sit amet pulvinar non,
        pretium molestie velit. Praesent lobortis turpis vitae semper tempor.
        Donec malesuada, lectus eget vestibulum ultrices, tortor orci tempor
        est, eget tincidunt odio felis sed enim. Ut porttitor dapibus turpis
        vitae imperdiet. Pellentesque quis erat eget orci consequat porttitor
        sed at justo. Cras malesuada iaculis mi non egestas. Phasellus est erat,
        facilisis a nibh vitae, varius lacinia dolor. Phasellus euismod
        tincidunt ante vitae viverra. In lacinia feugiat felis, eu fringilla
        libero venenatis convallis. Sed metus quam, consectetur in enim ac,
        egestas faucibus libero. In dictum, dui non egestas vulputate, lacus sem
        volutpat turpis, ac varius dui ipsum ac dolor. Ut non sem feugiat,
        gravida sem sit amet, ornare lectus. Pellentesque ante est, ullamcorper
        sed venenatis eget, ornare in arcu. Donec et orci sit amet arcu
        condimentum vestibulum. Praesent id ipsum vitae turpis viverra iaculis.
        Nullam porta tincidunt neque, nec cursus mi pharetra eget. Fusce tempor
        vestibulum tortor. In hac habitasse platea dictumst. Nam nec condimentum
        tortor. Etiam sollicitudin mauris ac arcu pharetra, nec consectetur quam
        laoreet. Mauris sollicitudin eu elit vitae ornare. In lorem augue,
        ultrices vel pellentesque vel, tincidunt at mi. Etiam ultricies lorem
        neque, pharetra commodo odio tempus non. Vivamus pellentesque varius
        dolor, vitae porta dolor. Suspendisse varius sem nec risus lobortis, nec
        pretium justo pharetra. Pellentesque vel nibh elementum, dapibus libero
        ac, pretium ligula. Donec nec ultricies mauris. Sed eleifend tincidunt
        ex non faucibus. Maecenas vel finibus odio, ut imperdiet mi. Aliquam sed
        facilisis purus. Etiam in elit et metus lacinia aliquam. Integer tortor
        tortor, mollis et hendrerit vel, consequat sit amet urna. Mauris at
        scelerisque dolor. Aliquam justo erat, rhoncus ut sem eu, faucibus
        tincidunt mi. Nullam quis sem pulvinar, consectetur dolor nec, ornare
        orci. Donec nec mollis tortor. Aenean tempor augue nec condimentum
        feugiat. Nam vel mattis sem. Mauris dui felis, blandit at varius vel,
        fermentum sed libero. Fusce in diam felis. Donec placerat, augue sit
        amet congue ultricies, neque justo luctus dolor, vitae faucibus felis
        magna ut erat.
      </p>
      <br />
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam vulputate
        magna ut urna lobortis suscipit. Vestibulum auctor enim ut nibh
        molestie, ut euismod justo finibus. Donec in lectus eget erat commodo
        euismod eget facilisis dui. Duis ullamcorper libero sem, non feugiat
        quam iaculis nec. Morbi nec lacus blandit elit hendrerit lacinia. Morbi
        id elit laoreet, vestibulum arcu ut, suscipit lectus. Aliquam volutpat
        tortor sed felis varius, eu blandit urna tristique. Donec luctus euismod
        nibh eget gravida. Pellentesque nec ligula tempus, aliquet ligula eu,
        accumsan neque. Proin dapibus ultrices urna, ut sagittis ligula
        tristique ut. Suspendisse mi eros, viverra sit amet pulvinar non,
        pretium molestie velit. Praesent lobortis turpis vitae semper tempor.
        Donec malesuada, lectus eget vestibulum ultrices, tortor orci tempor
        est, eget tincidunt odio felis sed enim. Ut porttitor dapibus turpis
        vitae imperdiet. Pellentesque quis erat eget orci consequat porttitor
        sed at justo. Cras malesuada iaculis mi non egestas. Phasellus est erat,
        facilisis a nibh vitae, varius lacinia dolor. Phasellus euismod
        tincidunt ante vitae viverra. In lacinia feugiat felis, eu fringilla
        libero venenatis convallis. Sed metus quam, consectetur in enim ac,
        egestas faucibus libero. In dictum, dui non egestas vulputate, lacus sem
        volutpat turpis, ac varius dui ipsum ac dolor. Ut non sem feugiat,
        gravida sem sit amet, ornare lectus. Pellentesque ante est, ullamcorper
        sed venenatis eget, ornare in arcu. Donec et orci sit amet arcu
        condimentum vestibulum.
      </p> */}
    </section>
  );
};

export default Home;
